import { render, staticRenderFns } from "./UserInvitations.vue?vue&type=template&id=8712281a&scoped=true&"
import script from "./UserInvitations.vue?vue&type=script&lang=js&"
export * from "./UserInvitations.vue?vue&type=script&lang=js&"
import style0 from "./UserInvitations.vue?vue&type=style&index=0&id=8712281a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8712281a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VContainer,VDataTable,VIcon})
